// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3cT45","footer":"ModalInfo_footer__3qGZ5"};